import { render, staticRenderFns } from "./VolunteerUnfavoritingModal.vue?vue&type=template&id=36975cca&scoped=true&"
import script from "./VolunteerUnfavoritingModal.vue?vue&type=script&lang=js&"
export * from "./VolunteerUnfavoritingModal.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerUnfavoritingModal.vue?vue&type=style&index=0&id=36975cca&prod&lang=scss&"
import style1 from "./VolunteerUnfavoritingModal.vue?vue&type=style&index=1&id=36975cca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36975cca",
  null
  
)

export default component.exports